import { AxiosResponse } from "axios";
import { endPoints } from "utils/constants";
import { crudService } from "services/crud.service";
import { NotificationManager } from "react-notifications";
import { initialCustomerDataState } from "store/constants";
import { createAsyncThunk, PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "store/helper";

const { customerEndPoint } = endPoints;

export const fetchCustomerData = createAsyncThunk(
  "customer/fetchCustomerData",
  async ({ customerId }: { customerId: string }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.getById(
        customerEndPoint,
        customerId
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateCustomerData = createAsyncThunk(
  "customer/updateCustomerData",
  async ({ updatedCustomerData, customerId }: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse = await crudService.update(
        `${customerEndPoint}`,
        customerId,
        updatedCustomerData
      );
      if (response.status === 204) {
        NotificationManager.success("Customer updated Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "customer/deleteCustomer",
  async ({ customerId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(
        customerEndPoint,
        customerId
      );

      if (response.status === 204) {
        NotificationManager.success("Customer Deleted Successfully.");
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      NotificationManager.error(errorMessage);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteExistingCustomer = createAsyncThunk(
  "customer/deleteExistingCustomer",
  async ({ customerId }: any, { rejectWithValue }) => {
    try {
      const response: any = await crudService.delete(
        customerEndPoint,
        customerId
      );

      if (response.status === 204) {
        return response.data;
      }
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);

      return rejectWithValue(error.message || errorMessage);
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState: initialCustomerDataState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch all lead activities
    builder
      .addCase(fetchCustomerData.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        fetchCustomerData.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.customerData = action.payload;
        }
      )
      .addCase(
        fetchCustomerData.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );

    //   update customer
    builder
      .addCase(updateCustomerData.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        updateCustomerData.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        updateCustomerData.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );

    //   delete customer
    builder
      .addCase(deleteCustomer.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(
        deleteCustomer.fulfilled,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
        }
      )
      .addCase(
        deleteCustomer.rejected,
        (state: any, action: PayloadAction<any>) => {
          state.loading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const CustomerDataReducer = customerSlice.reducer;
